module.exports = __webpack_public_path__ + "img/20190910161413360截图20190910141828561.1972c866.jpg";